export default "__VITE_ASSET__DiO2jloJ__"